import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const slice = createSlice({
  name: '$gatewayMode',
  initialState: null as string | null,
  reducers: {
    setGatewayMode(state, action: PayloadAction<string | null>) {
      return action.payload;
    },
  },
});

export const { setGatewayMode } = slice.actions;
export default slice.reducer;
